import { DYNAMIC_FILTERS } from '../../configs/filter-types';

export const filters = (state = [], action) => {
  switch (action.type) {
    case 'SET_FILTER_OPTIONS': {
      const { filterResults } = action.payload;
      const checkFilter = (filter) => {
        if (filter.type === 'PARENT') {
          return {
            ...filter,
            filters: filter.filters.map(checkFilter),
          };
        }
        if (!DYNAMIC_FILTERS.includes(filter.type)) {
          return filter;
        }
        return {
          ...filterResults
            .filter(Boolean)
            .find(({ key }) => filter.key === key),
          ...filter,
        };
      };
      const newState = state.map(checkFilter);

      return newState;
    }
    default:
      return state;
  }
};
